import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import { useLanguage } from "../LanguageContext";

const Layout = () => {
  const { language } = useLanguage();

  return (
    <div className={`app-layout ${language === "en" ? "" : "arabic"}`}>
      <Header />
      <main className="app-layout__main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
